
import invoices from '../api/invoices'

export const state = {
  completed_classes: [],
  invoices: [],
  invoices_get: [],
  invoice: Object,
  invoice_pagination: {},
  total_receivable: 0
}

export const getters = {
  completed_classes: state => state.completed_classes,
  invoices: state => state.invoices,
  invoices_get: state => state.invoices_get,
  invoice: state => state.invoice,
  invoice_pagination: state => state.invoice_pagination,
  total_receivable: state => state.total_receivable
}

export const mutations = {
  SET_COMPLETED_CLASSES (state, data) {
    state.completed_classes = data
  },
  SET_INVOICES (state, data) {
    state.invoices.push(data)
  },
  SET_INVOICES_GET (state, data) {
    state.invoices_get = data
  },
  SET_INVOICES_SHOW (state, data) {
    state.invoice = data
  },
  SET_INVOICE_PAGINATION (state, data) {
    state.invoice_pagination = data
  },
  SET_TOTAL_RECEIVABLE (state, data) {
    state.total_receivable = data
  }
}

export const actions = {
  GET_COMPLETED_CLASSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoices.getCompletedClass(data).then(response => {
        commit('SET_COMPLETED_CLASSES', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GENERATE_INVOICE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoices.generateInvoice(data).then(response => {
        commit('SET_INVOICES', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_INVOICES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoices.get(data).then(response => {
        commit('SET_INVOICES_GET', response.data.invoices.data)
        commit('SET_TOTAL_RECEIVABLE', response.data.total_receivable)
        let paginationData = {
          from: response.data.invoices.from,
          to: response.data.invoices.to,
          total: response.data.invoices.total,
          last_page: response.data.invoices.last_page
        }
        commit('SET_INVOICE_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CLEAR_COMPLETED_CLASSES ({ commit, getters }) {
    commit('SET_COMPLETED_CLASSES', [])
  },
  SHOW_INVOICE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoices.show(data).then(response => {
        commit('SET_INVOICES_SHOW', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  BULK_PROCESS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoices.bulkAction(data).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_INVOICE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      invoices.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SAVE_INVOICE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoices.update(data.data, data.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js